import { render, staticRenderFns } from "./SidebarNotification.vue?vue&type=template&id=2b455ff1&"
import script from "./SidebarNotification.vue?vue&type=script&lang=ts&"
export * from "./SidebarNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports